/**
 * Polskie święta ustawowe, dni wolne od pracy (runda 4 panelu „Klienci”, 2026-10-11): w kalendarzu firmy
 * i w małym kalendarzu okna terminu, żeby nikt nie umawiał montażu na Boże Ciało.
 *
 * Według ustawy o dniach wolnych od pracy: stałe daty i święta ruchome liczone od Wielkanocy (Poniedziałek
 * Wielkanocny +1, Zielone Świątki +49, Boże Ciało +60). Wigilia wolna od 2025 roku. Niedziele są wolne i tak,
 * więc Wielkanoc i Zielone Świątki (zawsze w niedzielę) są tu dla nazwy w kalendarzu.
 */

const STALE = [
  ['01-01', 'Nowy Rok'],
  ['01-06', 'Trzech Króli'],
  ['05-01', 'Święto Pracy'],
  ['05-03', 'Święto Konstytucji 3 Maja'],
  ['08-15', 'Wniebowzięcie NMP'],
  ['11-01', 'Wszystkich Świętych'],
  ['11-11', 'Święto Niepodległości'],
  ['12-24', 'Wigilia', 2025],
  ['12-25', 'Boże Narodzenie'],
  ['12-26', 'Drugi dzień Bożego Narodzenia'],
]
const OD_WIELKANOCY = [[0, 'Wielkanoc'], [1, 'Poniedziałek Wielkanocny'], [49, 'Zielone Świątki'], [60, 'Boże Ciało']]

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`

/** Niedziela Wielkanocna (kalendarz gregoriański, algorytm Meeusa/Jonesa/Butchera) jako RRRR-MM-DD. */
export const wielkanoc = (rok) => {
  const a = rok % 19
  const b = Math.floor(rok / 100)
  const c = rok % 100
  const d = Math.floor(b / 4)
  const e = b % 4
  const f = Math.floor((b + 8) / 25)
  const g = Math.floor((b - f + 1) / 3)
  const h = (19 * a + b - d - g + 15) % 30
  const i = Math.floor(c / 4)
  const k = c % 4
  const l = (32 + 2 * e + 2 * i - h - k) % 7
  const m = Math.floor((a + 11 * h + 22 * l) / 451)
  const miesiac = Math.floor((h + l - 7 * m + 114) / 31)
  const dzien = ((h + l - 7 * m + 114) % 31) + 1
  return iso(new Date(rok, miesiac - 1, dzien, 12))
}

const pamiec = new Map()

/** Święta roku: mapa RRRR-MM-DD → nazwa. */
export const swietaRoku = (rok) => {
  if (pamiec.has(rok)) return pamiec.get(rok)
  const m = new Map()
  STALE.forEach(([md, nazwa, od]) => { if (!od || rok >= od) m.set(`${rok}-${md}`, nazwa) })
  const w = new Date(`${wielkanoc(rok)}T12:00:00`)
  OD_WIELKANOCY.forEach(([n, nazwa]) => { const d = new Date(w); d.setDate(d.getDate() + n); m.set(iso(d), nazwa) })
  const posortowane = new Map([...m.entries()].sort(([a], [b]) => a.localeCompare(b)))
  pamiec.set(rok, posortowane)
  return posortowane
}

/** Nazwa święta w danym dniu (RRRR-MM-DD) albo null. */
export const swieto = (dzien) => {
  if (typeof dzien !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(dzien)) return null
  return swietaRoku(Number(dzien.slice(0, 4))).get(dzien) || null
}
